import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

// ✅ Safe JSON parse helper
const getStoredAuth = () => {
  try {
    const data = localStorage.getItem("auth");
    console.log("📦 Raw auth from localStorage:", data);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("❌ Auth parse error:", error);
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(getStoredAuth());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedAuth = getStoredAuth();
    console.log("🔁 Auth loaded on mount:", storedAuth);
    setAuth(storedAuth);
    setLoading(false);
  }, []);

  const login = (data) => {
    console.log("✅ login() called with:", data);
    localStorage.setItem("auth", JSON.stringify(data));
    setAuth(data);
  };

  const logout = () => {
    console.log("🚪 logout()");
    localStorage.removeItem("auth");
    setAuth(null);
    window.location.href = "/";
  };

  // 🔥 FIX IS HERE
  const isAuthenticated = !!auth?.accessToken;

  console.log("🔐 isAuthenticated:", isAuthenticated);
  console.log("🪪 auth state:", auth);

  return (
    <AuthContext.Provider
      value={{
        auth,
        login,
        logout,
        isAuthenticated,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
